import React from "react";
var __jsx = React.createElement;
import { createPortal } from "react-dom";
import { ModalManager, Screen } from './index';
var BottomSheet = function BottomSheet(_ref) {
  var open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    screens = _ref.screens,
    modalDesign = _ref.modalDesign,
    customClassName = _ref.customClassName;
  if (!open) return null;
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(ModalManager, {
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    screens: screens,
    modalDesign: modalDesign,
    customClassName: customClassName
  }, screens.map(function (screen, index) {
    return /*#__PURE__*/React.createElement(Screen, {
      key: "screen-number-".concat(index),
      screenIndex: index + 1
    }, screen.component);
  })), document.body);
};
export default BottomSheet;